// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2XDuR","header":"ReportDetails_header__3LGGw","title":"ReportDetails_title__2m6cv","left":"ReportDetails_left__Q5jBb"};